export default "__VITE_ASSET__CUAeFXEC__"